import { ConfigTenantInformedConsentFormV1 } from '@csp/dmdp-api-informed-consent-dto';
import { RestOptions } from '@csp/csp-common-model';
import { informedConsentPodUrl } from '../../dmdp-config/dmdpConfig';

const tenantConfigV1 = (): string => `${informedConsentPodUrl()}/config/tenant/v1`;

const getFormConfigurationUrl = (): string => `${tenantConfigV1()}/informed-consent-form-configuration`;

const getFormConfiguration = async ({ axios, signal }: RestOptions): Promise<ConfigTenantInformedConsentFormV1> => {
  const resp = await axios.get<ConfigTenantInformedConsentFormV1>(getFormConfigurationUrl(), {
    signal,
  });
  return resp.data;
};

export const TenantConfigRestServiceV1 = {
  getFormConfiguration,
  getFormConfigurationUrl,
};
